import moment from "moment";
import {StoreObjWithTtl} from "./types";
export class LocalStorageManager {
    public static testIsStoreUsable():boolean{

        const mod = 'local-storage-test';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (e) {
            return false;
        }
    }

    public static save<T>(key: string, dataT?:T,ttlInMinutes:number=30) {
        const expiryObj = {expiry: moment().add(ttlInMinutes, "minutes"),data:dataT} as  StoreObjWithTtl<T>;
        const dataString = JSON.stringify(expiryObj);
        localStorage.setItem(key, dataString);
    }

    public static load<T>(key: string): T | undefined {
        if(key===null || key===undefined) return undefined;
        const dataString = localStorage.getItem(key);
        if (dataString) {
            const dataObj: StoreObjWithTtl<T> = JSON.parse(dataString);


            if (dataObj && dataObj.data && dataObj.expiry && moment(dataObj.expiry).isAfter(moment())) {
                return dataObj.data!;
            }
        }
        return undefined;
    }
}

